import { styled } from '@mui/material/styles'
import { Input } from '@mui/material'

export const StyledInput = styled(Input)({
  fontFamily: "'Zen Kaku Gothic Antique', sans-serif",
  padding: '5px 15px',
  paddingRight: '0px',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '23px',
  backgroundColor: 'transparent',
  'div.Mui-disabled': {
    color: '#353F48',
    WebkitTextFillColor: '#353F48',
  },
})
